<template>
  <div>
    <div class="container">
      <van-nav-bar fixed left-arrow @click-left="onClickLeft">
        <template #left>
          <van-icon color="white" name="arrow-left" size="18" />
        </template>
        <template #title>
          <span style="color: #ffffff">维修评价</span>
        </template>
      </van-nav-bar>
      <div class="main">
        <div class="nav-placeholder"></div>
        <div class="repair_msg">
          <div
            class="repair_msg_room"
            v-html="'房\u3000&nbsp;&nbsp;间：' + repair.room"
          ></div>
          <div class="repair_msg_question">
            <span class="repair_msg_question_title">问题现象：</span
            >{{ repair.question }}
          </div>
          <div class="repair_msg_ul">报修时间：{{ repair.time }}</div>
        </div>
        <van-form @submit="onSubmit">
          <div class="repair_comment">
            <!-- <van-field label="报修状态" required colon>
              <template #input>
                <van-radio-group
                  v-model="radio"
                  @change="changeRadioValue"
                  direction="horizontal"
                >
                  <van-radio
                    v-for="(radio, index) in radioArr"
                    checked-color="#ee0a24"
                    icon-size="17"
                    :key="'r' + index"
                    :name="radio.id"
                    >{{ radio.value }}</van-radio
                  >
                </van-radio-group>
              </template>
            </van-field> -->
            <van-field required label="星级评价" colon v-if="repair.status == 9">
              <template #input>
                <van-rate size="19" v-model="starLevel" />
              </template>
            </van-field>
            <div class="repair_comment_text">
              <van-field
                v-model="commentData"
                type="textarea"
                maxlength="150"
                colon
                required
                rows="3"
                show-word-limit
                :border="false"
                name="comment"
                :label="lastFieldLabel"
                :placeholder="lastFieldPlaceholder"
              />
            </div>
          </div>
          <div class="repair_btn">
            <van-button
              round
              block
              type="info"
              color="#ba3939"
              native-type="submit"
            >
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import dayjs from "dayjs";
export default {
  name: "RepairComment",
  data() {
    return {
      repair: {},
      starLevel: 4,
      commentData: "",
      // radioArr: [
      //   { id: 9, value: "评价" },
      //   { id: 4, value: "驳回" },
      // ],
      // radio: 9,
      commentData: "",
      lastFieldLabel: "评论",
      lastFieldPlaceholder: "请填写文字评价",
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async onSubmit(values) {
      let data = {
        repairsId: this.repair.id,
        submitType: this.repair.status,
        starLevel: this.repair.status ? this.starLevel : "",
        commentData: this.commentData,
      };
      if(!this.commentData) {
        Toast(this.lastFieldPlaceholder)
        return;
      }
      let res = await this.$store.dispatch("repairsEvaluate", data);
      if (res.success) {
        Toast.success("提交成功！");
        this.$router.go(-1);
      } else {
        Toast.fail(res.msg);
      }
      // console.log(values)
    },
    changeStatusValue(name) {
      switch (parseInt(name)) {
        case 4:
          this.repair.status = name;
          this.lastFieldLabel = "驳回原因";
          this.lastFieldPlaceholder = "请填写驳回原因";
          break;
        case 9:
          this.repair.status = name;
          this.lastFieldLabel = "评论";
          this.lastFieldPlaceholder = "请填写文字评价";
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.repair = JSON.parse(this.$route.query.repair);
    this.changeStatusValue(this.repair.status)
  },
};
</script>

<style scoped>
.container {
  background-color: WhiteSmoke;
  height: 100vh !important;
}

.van-nav-bar {
  background: #ba3939;
}

.nav-placeholder {
  height: 92px;
}

.main {
  height: 100vh !important;
  overflow-y: scroll !important;
}

/* .main {
  height: fit-content;
  width: 100%;
} */
.repair_msg {
  height: fit-content;
  width: 100%;
  padding: 10px 35px;
  box-sizing: border-box;
  margin-top: 20px;
  background-color: white;

  /* border: 1px red solid; */
}

.repair_msg_room,
.repair_msg_ul {
  height: 50px;
  /* line-height: 50px; */
  /* border: 1px red solid; */
}

.repair_msg_room {
  font-size: 32px;
}

.repair_msg_ul {
  font-size: 28px;
  color: Gray;
  margin-top: 10px;
}
.repair_msg_question {
  display: flex;
  font-size: 28px;
  color: gray;
}

.repair_msg_question_title {
  min-width: fit-content;
}
.repair_comment {
  height: fit-content;
  width: 100%;
  background-color: white;
  margin-top: 20px;
  box-sizing: border-box;

  /* border: 1px red solid; */
}

.repair_comment_stars {
  display: flex;
  align-items: center;
  height: 100px;
  font-size: 35px;
  width: 100%;
}

.repair_comment_text {
  height: fit-content;
  padding-bottom: 20px;
}

.repair_btn {
  margin-top: 50px;
  padding: 0 50px;
}
</style>
